import React, { useEffect, useState } from "react";

//UI Material
import { CircularProgress, Grid } from "@mui/material";

//Local components
import TaskCard from "./TaskCard";
import Selector from "../basics/Selector";

//Helpers
import {
  typographyForText,
} from "../../Helpers/typography";
import { fetchWithTokenJSONPost } from "../../Helpers/network";

const filterBy = [
  "Tareas Pendientes",
  "Tareas Finalizadas",
  "Tareas Canceladas",
  "Todas las tareas",
];

export default function MySpace() {
  // ==========>Component States<==========
  //State for setting loader for tasks data
  const [dataLoader, setDataLoader] = useState(true);
  //State to handle tasks status filter
  const [taskStatus, setTaskStatus] = useState(0);
  //State for tasks data
  const [data, setData] = useState([]);

  //Function to filer data
  const filteredTasks = () => {
    switch (taskStatus) {
      case 0:
        return data.filter((task) => !task.completed && !task.canceled);
      case 1:
        return data.filter((task) => task.completed && !task.canceled);
      case 2:
        return data.filter((task) => task.canceled);
      default:
        return data;
    }
  };

  // ==========>Component Functions<==========
  //Function to get user's tasks
  const getUserTasks = async () => {
    try {
      const requestResponse = await fetchWithTokenJSONPost(
        `/tasks/get-user-tasks`,
        {}
      );
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setData(jsonResponse.data.sort((a, b) => new Date(a.dueDate) - new Date(b.dueDate)));
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (e) {}
    setDataLoader(false);
  };

  //The useEffect checks for token validation
  useEffect(() => {
    getUserTasks();
  }, []);

  //Function to generate tasks
  const generateTasks = () => {
    let myTasks = [];

    for (const task of filteredTasks()) {
      myTasks.push(
        <Grid item key={task.taskNumber} xs={12} sm={6} md={4} lg={3}>
          <TaskCard task={task} getTasks={getUserTasks} />
        </Grid>
      );
    }

    return myTasks;
  };

  //Function to check if there are tasks in user's account
  const checkForTasksLength = () => {
    if (!data.length) {
      return (
        <Grid item xs={12} align="center">
          {typographyForText("Aún no tienes tareas asignadas.")}
        </Grid>
      );
    } else {
      return generateTasks();
    }
  };

  //Function to select page component according to loading status
  const displayRequestedData = () => {
    if (dataLoader) {
      return (
        <Grid item xs={12} md={12}>
          <CircularProgress />
        </Grid>
      );
    } else {
      return checkForTasksLength();
    }
  };

  // ==========>Component<==========
  return (
    <Grid container spacing={2} textAlign="center">
      <Grid item xs={12} align="center">
        <Selector
          width="200px"
          value={taskStatus}
          handleChange={(e) => {
            setTaskStatus(e.target.value);
          }}
          content={filterBy}
        />
      </Grid>
      {displayRequestedData()}
    </Grid>
  );
}
